import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const concernApi = createApi({
    reducerPath: 'concernApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://test-backend.glowthentic.store/api' }),
    endpoints: builder => ({
        getConcern: builder.query({
            query: () => '/concern',
        }),

    })
})

export const {
    useGetConcernQuery
} = concernApi;

export default concernApi;
